import { Box } from '@mui/material';
import { TimeslotButton } from './TimeslotButton';
import type { Timeslot } from '@/types';

interface TimeslotGridProps {
  timeslots: Timeslot[];
  selectedTimeslot: Timeslot | null;
  onSelectTimeslot: (timeslot: Timeslot) => void;
  showDuration?: boolean;
}

export function TimeslotGrid({
  timeslots,
  selectedTimeslot,
  onSelectTimeslot,
  showDuration = false,
}: TimeslotGridProps) {
  const isSelected = (timeslot: Timeslot) => {
    if (!selectedTimeslot) return false;
    return (
      selectedTimeslot.from === timeslot.from &&
      selectedTimeslot.to === timeslot.to &&
      selectedTimeslot.area_uuid === timeslot.area_uuid
    );
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, 1fr)',
          sm: 'repeat(3, 1fr)',
          md: 'repeat(4, 1fr)',
        },
        gap: 2,
      }}
    >
      {timeslots.map((timeslot, index) => (
        <Box key={`${timeslot.from}-${timeslot.area_uuid || 'no-area'}-${index}`}>
          <TimeslotButton
            timeslot={timeslot}
            selected={isSelected(timeslot)}
            onClick={onSelectTimeslot}
            showDuration={showDuration}
          />
        </Box>
      ))}
    </Box>
  );
}
